// extracted by mini-css-extract-plugin
export default {"container":"ListItem_container__kcht4","point":"ListItem_point__m4B4p","text":"ListItem_text__PcTch"};